import React from "react";

const Projects = () => {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-Our-Initiatives.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Our Initiatives</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Our Initiatives</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="portfolio-details-style01">
        <div className="container">
          <div className="col-lg-12">
            <div>
              {/* Monodeep Abasan */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                <img
                  src="img/portfolio/monodeep-abasan.jpg"
                  alt="Monodeep Abasan"
                  className="border-radius-10"
                />
              </div>
              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Monodeep Abasan: A Residential Project for Differently-Abled
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">1</span>Now differently-abled students will have access to a more inclusive and secure environment at Monodeep Abasan.
                    </p>
                    <p className="mb-2">
                      On January 15th, 2025, the foundation stone of Monodeep Abasan was laid during the Bhoomi Puja ceremony. A home designed for differently-abled children, where they will live not in isolation, but with love and care.
                    </p>
                    <p className="mb-2">
                      As a visionary residential project by Matribedi Shamayita Monodeep under Shamayita Math, the initial phase includes 16 spacious 3-BHK flats where families will live together.
                    </p>
                    <p className="mb-0">
                      The unique residential complex is now in the final stage of completion and will soon be ready to welcome families into a compassionate and secure living space.
                    </p>
                  </div>
                </div>
              </div>

              {/* Colours of Imagination: Drawing Workshop at Marang Buru Learning Centre */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                <img
                  src="img/portfolio/Initiatives-1.jpg"
                  alt="Drawing Workshop"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9 pt-4">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Colours of Imagination: Drawing Workshop at Marang Buru Learning Centre
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">2</span>Students at the Marang Buru Learning Centre in Kendrabonathole spent a day immersed in a drawing workshop that turned classrooms into studios. Children explored impression drawing, watercolour painting, and vibrant nature-themed art—flowers, trees, and landscapes coming alive on paper.
                    </p>
                    <p className="mb-0">
                      Supported by a visitor from Denmark, the workshop sparked excitement and confidence among students, showing how art can become a powerful tool for expression and joy.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/Initiatives-${i + 2}.jpg`}
                        alt={`Drawing Workshop ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Nutrition Begins at Home: Food, Faith, and Wellbeing */}
              <div className="mb-1-6 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                <img
                  src="img/portfolio/Initiatives-5.jpg"
                  alt="Nutrition Begins at Home"
                  className="border-radius-10"
                />
              </div>
              <div className="row mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9 pt-4">
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="section-title01 pe-xl-15">
                    <h2 className="mb-0 display-5 font-weight-800 lh-1 ls-minus-2px">
                      Nutrition Begins at Home: Food, Faith, and Wellbeing
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div>
                    <p className="mb-2">
                      <span className="box-letter">3</span>Shamayita Math has begun strengthening community nutrition through a holistic approach that integrates food security, traditional knowledge, and spiritual values. Guided by the belief that nourishing the body is a sacred responsibility, food is viewed not merely as sustenance but as a form of seva connecting people, nature, and the divine. The initiative focuses on reviving local food systems and promoting dietary diversity through indigenous pulses, oilseeds, seasonal vegetables, forest foods, and backyard produce. Women-led nutrition gardens and traditional food practices are being encouraged to help families adopt balanced, affordable, and culturally rooted diets. Across villages, families are rediscovering the value of eating local and seasonal foods, strengthening physical health, mental wellbeing, and community harmony. This initiative aims to nurture healthier communities—inside and out.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row border-bottom mb-1-9 pb-1-9 pb-lg-8 align-items-center mt-n1-9">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-4 wow fadeIn" data-wow-delay="100ms" key={i}>
                    <div className="image-hover">
                      <img
                        src={`img/portfolio/Initiatives-${i + 6}.jpg`}
                        alt={`Nutrition Initiative ${i + 1}`}
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default Projects;